import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Link } from '@bibliocommons/base-links';

import './DistinctionItem.scss';

// TODO: distinction items will probably have a slightly different shape then this
export default function DistinctionItem({ item }) {
  const title = item.get('url') ? (
    <Link className="distinction-title" href={item.get('url')} dataKey="distinction-item-link">
      {item.get('title')}
    </Link>
  ) : (
    <div className="distinction-title unlinked">{item.get('title')}</div>
  );

  return (
    <div className="cp-distinction-item">
      {title}
      <div className="subtitle">{item.get('subtitle')}</div>
    </div>
  );
}

DistinctionItem.propTypes = {
  item: ImmutablePropTypes.map.isRequired
};
